import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";

const delivery_time_list = [
    { value: "", label: "未選択" },
    { value: "0812", label: "午前中" },
    { value: "1416", label: "14～16時" },
    { value: "1618", label: "16～18時" },
    { value: "1820", label: "18～20時" },
    { value: "1921", label: "19～21時" },
];

const SelectDeliveryTime = (props) => {
    const { disabled, value, disableSelect, noAM, ...other } = props;

    const [delivery_time, set_delivery_time] = useState();

    useEffect(() => {
        set_delivery_time(value);
    }, [value]);

    const HandleChange = (e) => {
        set_delivery_time(e.currentTarget.value);
    };

    const DisableValue = () => {
        let time;
        switch (delivery_time) {
            case "0812":
                time = "午前中";
                break;
            case "1416":
                time = "14～16時";
                break;
            case "1618":
                time = "16～18時";
                break;
            case "1820":
                time = "18～20時";
                break;
            case "1921":
                time = "19～21時";
                break;
            default:
                time = "未選択";
                break;
        }

        return (
            <Typography variant="body1" gutterBottom component="div" whiteSpace="pre-wrap">
                {`    ${time}`}
            </Typography>
        );
    };

    return (
        <>
            {disableSelect ? (
                <DisableValue />
            ) : (
                <TextField
                    id="delivery_time"
                    select
                    name="delivery_time"
                    label="お届け時間"
                    fullWidth
                    variant="outlined"
                    SelectProps={{
                        native: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                    disabled={disabled}
                    onChange={HandleChange}
                    value={delivery_time}
                    {...other}
                >
                    {delivery_time_list
                    .filter(time => (!noAM || time.value != "0812"))
                    .map((time, index) => (
                        <option key={index} value={time.value}>
                            {time.label}
                        </option>
                    ))}
                </TextField>
            )}
        </>
    );
};

export default SelectDeliveryTime;
